// Polls the course report's status while it is being written, and reloads
// the page when the row is readable — the server renders the report, so the
// browser only needs to know when.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside the wizard and the assessments modal.
//
// Gives up when the server's own STALE_AFTER has passed (shipped in the
// waiting page's data attribute from the model, so the browser's patience
// and the watchdog's are one number) or when the row reports failure, and
// then reveals the retry form. Without this module the page still works:
// the refresh link is a plain GET.

const POLL_MS = 3000;
const GRACE_MS = 30000;

function setup() {
  const root = document.querySelector("[data-course-report-poll]");
  if (root === null) return;

  const url = root.dataset.statusUrl;
  const staleAfterMs = Number(root.dataset.staleAfterMs) || 480000;
  const working = root.querySelector("[data-course-report-working]");
  const stalled = root.querySelector("[data-course-report-stalled]");
  const startedAt = Date.now();

  function stall() {
    if (working) working.hidden = true;
    if (stalled) stalled.hidden = false;
  }

  function tick() {
    fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (data === null) return schedule();
        if (data.readable) return window.location.reload();
        if (!data.working) return stall();
        if (Date.now() - startedAt > staleAfterMs + GRACE_MS) return stall();
        return schedule();
      })
      .catch(schedule);
  }

  function schedule() {
    window.setTimeout(tick, POLL_MS);
  }

  schedule();
}

document.addEventListener("DOMContentLoaded", setup);
